function getLanguageKey(data, key, value) {
    return data.replace("{" + key + "}", value);
}

var registerPasswordRule = function() {
    var wrapper = $(".form-password-detail");
    var alphabeticalEl = $("[data-pass-alphabetical]");
    var numericEl = $("[data-pass-numeric]");
    var specialEl = $("[data-pass-special]");
    var lengthEl = $("[data-pass-length]");
    var passwordLength = lengthEl.attr("data-pass-length");
    var validator = $("[data-security-form]").length
        ? $("[data-security-form]").validate()
        : null;
    var validation = function(type, value, param) {
        var upper = new RegExp("^(?=.*[A-ZŞÇĞÜİÖ])");
        var lower = new RegExp("^(?=.*[a-zşçüğöı])");
        var isAlphabetical = upper.test(value) && lower.test(value);
        isAlphabetical
            ? alphabeticalEl.addClass("-success").removeClass("-error")
            : alphabeticalEl.addClass("-error").removeClass("-success");
        var numeric = new RegExp("^(?=.*[0-9])");
        var isNumeric = numeric.test(value);
        isNumeric
            ? numericEl.addClass("-success").removeClass("-error")
            : numericEl.addClass("-error").removeClass("-success");

        var specail = new RegExp(
            "^(?=.*[\\!\\@\\#\\$\\%\\^\\+\\&\\*\\(\\)\\,\\.\\?\\:\\{\\}\\|\\<\\>\\_\\-\"\\'\\;])"
        );
        var isSpecial = specail.test(value);
        isSpecial
            ? specialEl.addClass("-success").removeClass("-error")
            : specialEl.addClass("-error").removeClass("-success");

        var length = new RegExp("^(?=.{" + passwordLength + ",})");
        var isLength = length.test(value);
        
        var isConfirm = value && value === $('[name=' + param + ']').val() && $('[name=' + param + ']').hasClass('valid')

        isLength
            ? lengthEl.addClass("-success").removeClass("-error")
            : lengthEl.addClass("-error").removeClass("-success");
        if (!wrapper.hasClass("-active")) wrapper.addClass("-active");
        switch (type) {
            case "alphabetical":
                return isAlphabetical;
                break;
            case "numeric":
                return isNumeric;
                break;
            case "length":
                return isLength;
                break;
            case "special":
                return isSpecial;
                break;
            case "password_confirmation":
                return isConfirm;
                break;
            default:
                break;
        }
    };
    jQuery.validator.addMethod(
        "alphabetical",
        function(value, element, param) {
            var param = validation("alphabetical", value);
            return param;
        },
        ""
    );
    jQuery.validator.addMethod(
        "numeric",
        function(value, element, param) {
            var param = validation("numeric", value);
            return param;
        },
        ""
    );
    jQuery.validator.addMethod(
        "length",
        function(value, element, param) {
            var param = validation("length", value);
            return param;
        },
        ""
    );
    jQuery.validator.addMethod(
        "special",
        function(value, element, param) {
            var param = validation("special", value);
            return param;
        },
        ""
    );
    jQuery.validator.addMethod(
        "password_confirmation",
        function(value, element, param) {
            var param = validation("password_confirmation", value, param);
            return param;
        },
        $('#password_confirmation').attr('validation-message')
    );

    $("[security-password]").rules("add", {
        alphabetical: true,
        numeric: true,
        length: true,
        special: $("[security-password]").data("special-character"),
    });
    var isValid = function() {
        if (!wrapper.hasClass("-active")) wrapper.addClass("-active");
        if (validator) validator.element("[security-password]");
    };
    $("[security-password]").on("blur", isValid);
    // $("[security-password]").on("focus", isValid);
};
registerPasswordRule();
